export default __webpack_public_path__ + "static/media/Finally.43662468.jpg";